import { render, staticRenderFns } from "./AddSupervisorModalProjectDetail.vue?vue&type=template&id=3c4fe4d0&"
import script from "./AddSupervisorModalProjectDetail.vue?vue&type=script&lang=js&"
export * from "./AddSupervisorModalProjectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports